import Bugsnag from '@bugsnag/js';
import constate from 'constate';

import { IAuthUser } from 'auth/types';
import { BUGSNAG_API_KEY } from 'global';

const useBugsnag = () => {
  const setBugsnagUser = (user: IAuthUser) => {
    if (!BUGSNAG_API_KEY) {
      return;
    }
    const bugsnagUser = user
      ? {
          id: user.id.toString(),
          email: user.email,
          name: `${user.firstName} ${user.lastName}`,
        }
      : {};

    Bugsnag.setUser(bugsnagUser?.id, bugsnagUser?.email, bugsnagUser?.name);
  };

  const clearBugsnagUser = () => {
    if (!BUGSNAG_API_KEY) {
      return;
    }

    Bugsnag.setUser();
  };

  return {
    setBugsnagUser,
    clearBugsnagUser,
  };
};

export const [BugsnagProvider, useBugsnagContext] = constate(useBugsnag);
